import { http } from 'vue'

let beforeRequest = false
let beforeRequestGetMessages = false
let beforeRequestPutMessages = false

export default {
  postRentPreRegistration (context, params = {}) {
    return http.post('rent_pre_registrations', params.data)
  },
  loadRentPreRegistrations (context, params = {}) {
    let pageParam = '&page=' + ((params.page) ? params.page : 1)
    let madeParam = '&made=' + ((params.made) ? 1 : 0)
    let idParam = params.id ? '&order_id=' + params.id : ''
    let statusParam = params.status ? '&status=' + params.status : ''
    let searchParam = params.search ? '&search=' + params.search : ''
    let productParam = params.product ? '&product=' + params.product : ''
    let clientIdParam = params.clientId ? '&client_id=' + params.clientId : ''
    let periodParam = params.period ? '&period=' + params.period : ''
    return http.get('rent_pre_registrations?company_id=' + params.companyId + idParam + pageParam + madeParam + searchParam + productParam + clientIdParam + statusParam + periodParam, {
      before (request) {
        if (beforeRequest) beforeRequest.abort()
        beforeRequest = request
      }
    })
  },
  loadRentPreRegistrationDetails (context, params = {}) {
    let withParam = (params.with) ? '&with=' + params.with : ''
    return http.get('rent_pre_registrations/' + params.rentId + '?company_id=' + params.companyId + withParam)
  },
  loadRentPreRegistrationsCount (context, params = {}) {
    return http.get('rent_pre_registrations/count')
  },
  putRentPreRegistration (context, params = {}) {
    return http.put('rent_pre_registrations/' + params.id, params.data)
  },
  getRentPreRegistrationMessages (context, params = {}) {
    let companyIdParam = '?company_id=' + params.companyId
    let chatParam = params.chat ? '&chat=' + params.chat : ''
    return http.get('rent_pre_registrations/messages/' + params.orderId + companyIdParam + chatParam, {
      before (request) {
        if (beforeRequestGetMessages) beforeRequestGetMessages.abort()
        beforeRequestGetMessages = request
      }
    })
  },
  postRentPreRegistrationMessage (context, params = {}) {
    return http.post('rent_pre_registrations/message/' + params.orderId, params.data)
  },
  putRentPreRegistrationMessage (context, params = {}) {
    return http.put('rent_pre_registrations/message/' + params.messageId, {}, {
      before (request) {
        if (beforeRequestPutMessages) beforeRequestPutMessages.abort()
        beforeRequestPutMessages = request
      }
    })
  },
  loadRentPreRegistrationsMessagesCount (context, params = {}) {
    return http.get('rent_pre_registrations/count_messages')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rent_pre_registrations/actions.js